import { RouterOutlet } from '@angular/router';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { enableZoomWebView } from './utils/webview/webview.util';
import { release } from '@release';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
  selector: 'ess-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  loading = true;

  constructor(private overlayContainer: OverlayContainer) {
    /* eslint-disable-next-line no-console */
    console.log(` ℹ️ Release: %c${release}`, 'color: blue');
  }

  ngOnInit(): void {
    enableZoomWebView();
    this.overlayContainer.getContainerElement().setAttribute('role', 'region');
  }
}
